import { ProductionOrder, SortingModes } from '@app:types';

export type OrdersState = {
  totalItems: number;
  isLoading: boolean;
  page: number;
  limit: number;
  items: ProductionOrder[];
  sortedBy: {
    createdAt: SortingModes;
  };
  lastUpdated: string | null;
};

export const initialState: OrdersState = {
  isLoading: false,
  items: [],
  page: -1,
  limit: 10,
  totalItems: 0,
  sortedBy: {
    createdAt: SortingModes.ASC,
  },
  lastUpdated: null,
};
